import styled from 'styled-components';

import { Loading } from 'components/Loading';
import ShipperOrderTableGroup from './container';

export const StyledLoading = styled(Loading)`
  margin: 20px auto;
`;

export default styled(ShipperOrderTableGroup)`
  padding-bottom: ${(props) => props.theme.base.gridSizes.L};
`;
